/* istanbul ignore file */ /* plugin extension code */
/* cSpell:ignore Slidedown */

import OneSignal from 'react-onesignal';

/**
 * @see https://onesignal.com/blog/how-to-integrate-push-notifications-in-react/
 */
import { getEnvVars } from '../../../utils';

const { ONE_SIGNAL_APP_ID = '' } = getEnvVars();

const isOneSignalCredentialsProvided = Boolean(ONE_SIGNAL_APP_ID);

export async function initOneSignal() {
  if (!isOneSignalCredentialsProvided) return;

  await OneSignal.init({ appId: ONE_SIGNAL_APP_ID });
  await OneSignal.showSlidedownPrompt();

  return true;
}

export async function startOneSignalUserSession(userId: string) {
  if (!isOneSignalCredentialsProvided) return;

  await OneSignal.setExternalUserId(userId);
}

export async function resetOneSignalUserSession() {
  if (!isOneSignalCredentialsProvided) return;

  await OneSignal.removeExternalUserId();
}

export { default as OneSignal } from 'react-onesignal';
